import { PresenceRulesPayload } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

/**
 * The rules a camera will run: those scoped to it, plus unscoped rules
 * whose zone name it carries.
 */
export function usePresenceRules(camId: string, enabled = true) {
  const url = `/v2/orm/presence/rules?cameraId=${encodeURIComponent(camId)}`;
  const request = new Request(url);

  return useAuthenticatedRequest<PresenceRulesPayload>(request, {
    queryKey: ['presence-rules', camId],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    enabled,
  });
}

export default usePresenceRules;
